export const FLAG_GETTING_PARCEL_SERVICE_TYPES =
  'FLAG_GETTING_PARCEL_SERVICE_TYPES';
export const GET_PARCEL_SERVICE_TYPES = 'GET_PARCEL_SERVICE_TYPES';
export const CLEAR_PARCEL_SERVICE_TYPES = 'CLEAR_PARCEL_SERVICE_TYPES';
export const FLAG_PARCEL_SERVICE_TYPE_ACTIVITY =
  'FLAG_PARCEL_SERVICE_TYPE_ACTIVITY';
export const GET_PARCEL_SERVICE_TYPE = 'GET_PARCEL_SERVICE_TYPE';
export const CLEAR_PARCEL_SERVICE_TYPE = 'CLEAR_PARCEL_SERVICE_TYPE';
